import * as Data from "~/Data";
import { Status } from "~/Driver";
import * as Log from "~/Log";
import { Time } from "~/Time";

export type State = {
  readonly event?: Log.Event.Event;
  // readonly driver: Data.Reference.Reference;
  readonly driverStatus: Status.Status;
  readonly startTime: Time.DateTime;
  readonly endTime: Time.DateTime;
  readonly location: string;
  readonly workOrder?: Data.Reference.Reference;
  readonly workCodes?: readonly Data.Reference.Reference[];
  readonly job?: Data.Reference.Reference;
  readonly notes: string;
};

export namespace State {
  export const toSuggestion = (
    state: State
  ): Omit<Log.Suggestion.Suggestion, "sources" | "event" | "driver"> => ({
    id: "0",
    status: state.driverStatus,
    location: state.location,
    ...Time.Interval.Stopped.fromDateTimes(state.startTime, state.endTime),
    workOrder: state.workOrder,
    workCodes: state.workCodes,
    job: state.job,
    notes: state.notes,
  });
}
